import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const DonorRoute = memo(function DonorRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/authentication");
    } else if (
      session?.status === "authorized" &&
      session?.user?.roleCode === "admin"
    ) {
      navigate("/admin/dashboard");
    } else if (
      session?.status === "authorized" &&
      session?.user?.roleCode === "user"
    ) {
      navigate("/user/dashboard");
    }
  }, [session?.status, session?.user?.roleCode, navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" && session?.user?.roleCode === "donor"
    ? children
    : null;
});

export default DonorRoute;
